import React, { Component } from "react";
import { getEntrySubTypes } from "../../services/generalLedgerService";

import { generateIncomeReport } from "../../services/reportService";

import BlockUi from "react-block-ui";
import "react-datepicker/dist/react-datepicker.css";
import ReactToPrint from "react-to-print";
import IncomePrintReport from "./print/incomemonthly";

class IncomeReport extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date(),
    projects: [],
    showSalaryForm: false,
    showError: false,
    showErrorGenerateSalry: false,
    salaries: [],
    open: false,
    openSingle: false,
    totalSalaryAmount: 0,
    month: "",
    year: "",
    grand: 0,
    grandHours: 0,
    salesData: [],
    expenseData: [],
    salesMonthWiseTotal: [],
    expenseMonthWiseTotal: [],
    monthText: "",
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    this.loadProjects();
    this.setState({ blocking: false });
  }

  async loadProjects() {
    let params = {
      company: 1,
      entryType: "project",
    };
    const { data: res } = await getEntrySubTypes(params);

    this.setState({ projects: res.accounts });
  }

  doSubmit = async () => {
    try {
      // var event = new Date(this.state.startDate);
      // let startDate = JSON.stringify(event);
      // startDate = startDate.slice(1, 11);

      // event = new Date(this.state.endDate);
      // let endDate = JSON.stringify(event);
      // endDate = endDate.slice(1, 11);

      const month = document.getElementById("month").value;
      const year = document.getElementById("year").value;
      const r_type = document.getElementById("r_type").value;

      // if (projectID == "") {
      //   toast.warning("Please select project to continue.");
      //   this.setState({ blocking: false });
      //   return false;
      // }

      this.setState({
        showError: false,
        blocking: true,
      });

      const verifyData = {
        //startDate: startDate,
        //endDate: endDate,
        month: month,
        year: year,
        r_type: r_type,
      };

      const res = await generateIncomeReport(verifyData);

      this.setState({
        showError: false,
        showSalaryForm: true,
        blocking: false,
        salesData: res.data.reportData.salesData,
        salesMonthWiseTotal: res.data.reportData.salesMonthWiseTotal,
        expenseData: res.data.reportData.expenseData,
        expenseMonthWiseTotal: res.data.reportData.expenseMonthoWiseTotal,
        grand: res.data.grand,
        grandHours: res.data.grandHours,
        monthText: res.data.monthText,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    // if (auth.getCurrentUser().role != "salary-admin") {
    //   return "Your are authorized to perform this action.";
    // }

    const {
      salesData,
      salesMonthWiseTotal,
      expenseData,
      expenseMonthWiseTotal,
    } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Income Report</h1>
        <div className="grid income-filters">
          <select name="r_type" id="r_type" className="input">
            <option selected value="">
              --Select Report Type--
            </option>
            <option value="scrap">Scrap</option>
            <option value="jv">Jv</option>
          </select>
          <div></div>
          <select name="year" id="year" className="input">
            <option selected value="">
              --Select Year--
            </option>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
          </select>
          <div></div>
          <select name="month" id="month" className="input">
            <option selected value="">
              --Select Month--
            </option>
            <option value="1">Janaury</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
          <div></div>
          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
        </div>

        <div
          className="scrap-report"
          style={{
            display: this.state.showSalaryForm == true ? "block" : "none",
          }}
        >
          <div className="scrap-report__print">
            <ReactToPrint
              trigger={() => <a href="#">Print this out!</a>}
              content={() => this.componentRef}
            />
          </div>

          <IncomePrintReport
            salesData={salesData}
            salesMonthWiseTotal={salesMonthWiseTotal}
            expenseData={expenseData}
            expenseMonthWiseTotal={expenseMonthWiseTotal}
            month={this.state.monthText}
            project={this.state.project}
            grand={this.state.grand}
            grandHours={this.state.grandHours}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </BlockUi>
    );
  }
}

export default IncomeReport;
